import React from "react";

const Background = ({ children }) => {
  const baseClasses = "w-screen h-screen py-4 flex flex-col"

  // Theme classes
  const lightThemeClasses = "bg-slate-50"
  const darkThemeClasses = "dark:bg-gradient-to-r dark:from-[#27274D] dark:to-[#24294A]"

  // Combine classes
  const backgroundClasses = [baseClasses, darkThemeClasses, lightThemeClasses]

  return <div className={backgroundClasses.join(" ")}>{children}</div>;
};

export default Background;
